import { FaAngleRight } from "react-icons/fa6";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { Link } from "react-router-dom";
import { useState } from "react";
import OrderAndMenuTable from "../Restaurants/Operations/OrderAndMenuTable";
import PromotionsTable from "./MenuOversight/PromotionsTable";
import FlaggedItemsTable from "./MenuOversight/FlaggedItemsTable";

type MenuTab = "menu" | "promotions" | "flagged";

const MenuOversight = () => {
  const [activeTab, setActiveTab] = useState<MenuTab>("menu");

  const getTabDescription = () => {
    switch (activeTab) {
      case "menu":
        return "Review and manage vendor menu items and content.";
      case "promotions":
        return "Manage promotional campaigns and special offers.";
      case "flagged":
        return "Review and moderate flagged content and items.";
      default:
        return "Review and manage vendor menu items and promotional content.";
    }
  };

  return (
    <section className="font-mont">
      <div className="flex items-start gap-4">
        <Link to="/dashboard/restaurants">
          <button className="cursor-pointer p-2 rounded-full bg-[#008B5014]">
            <MdOutlineKeyboardBackspace className="w-6 h-6" />
          </button>
        </Link>
        <article>
          <h1 className="text-2xl font-medium mb-2 inline-flex items-center gap-3">
            <span className="font-semibold">Operations</span> <FaAngleRight />
            Menu Oversight
          </h1>
          <p className="text-sm">
            {getTabDescription()}
          </p>
        </article>
      </div>
      
      <section className="bg-[#EEEEEE40] px-3 py-5 my-3">
        {/* Tab Navigation */}
        <nav className="bg-white p-5 w-fit mb-5">
          <ul className="flex gap-10 text-base font-medium">
            <li>
              <button
                type="button"
                className={`cursor-pointer p-2 ${
                  activeTab === "menu" ? "bg-[#EEEEEE40] text-secondary" : "text-gray-600"
                }`}
                onClick={() => setActiveTab("menu")}
              >
                Menu Items
              </button>
            </li>
            <li>
              <button
                type="button"
                className={`cursor-pointer p-2 ${
                  activeTab === "promotions" ? "bg-[#EEEEEE40] text-secondary" : "text-gray-600"
                }`}
                onClick={() => setActiveTab("promotions")}
              >
                Promotions
              </button>
            </li>
            <li>
              <button
                type="button"
                className={`cursor-pointer p-2 ${
                  activeTab === "flagged" ? "bg-[#EEEEEE40] text-secondary" : "text-gray-600"
                }`}
                onClick={() => setActiveTab("flagged")}
              >
                Flagged Items
              </button>
            </li>
          </ul>
        </nav>

        {/* Tab Content */}
        {activeTab === "menu" && <OrderAndMenuTable table="menu" />}
        {activeTab === "promotions" && <PromotionsTable />}
        {activeTab === "flagged" && <FlaggedItemsTable />}
      </section>
    </section>
  );
};

export default MenuOversight;